<!-- 捐赠排行页面
  捐赠详细信息页面点击捐赠鸣谢下的更多时 跳转至该页面
捐赠指数页面点击捐赠排行时跳转至该页面 -->
<template>
  <div class="ranking">
    <div class="myRank" v-if="sums != ''">
      <div class="myRankNum">{{ sort }}</div>
      <div class="myRankWord">我的累计捐赠金额</div>
      <div class="myRankMoney">￥{{sums }}元</div>
    </div>
    <div class="myRank" v-else>
      <div class="myRankWordZero">您的捐赠金额为0元</div>
      <button class="donationBtn" @click="onDonateBtnClick">去捐赠</button>
      <!-- <div class="myRankWordZero">
        捐赠功能开发中
      </div> -->
    </div>
    <div class="table">
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <el-table :data="donationDetail || []" :border="false" type="index" header-cell-style="text-align:center" style="width: 100%; border-radius: 15px;">
          <!-- <el-table-column type="index" width="40px"> </el-table-column> -->
          <el-table-column prop="ranking" label="排名" width="80px" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"> </el-table-column>
          <el-table-column prop="major" label="专业" align="center"> </el-table-column>
          <el-table-column prop="totalMoney" label="累计捐赠金额" align="center"> </el-table-column>
        </el-table>
      </van-list>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openid: window.localStorage.getItem("openid"),
      // openid: "oKMob64cF73I3t5_sivE238GkSGY",
      myDonation: '',
      sums:'',
      sort:'',
      donationDetail: [],
      postDonationList: {
        currentPage: 1,
        perPage: 20,
      },
      loading: false,
      finished: false,
      lastPage: '',
    };
  },
  created() {
    this.getDonationList();
  },
  methods: {
    onDonateBtnClick() {
      this.$router.push('/donationList');
    },
    async getDonationList() {
      const result = await this.$http.get('/donates/getDonateRank', {
        params: { ...this.postDonationList},
      });
      //  this.donationDetail = result.data.data.list;
      //  this.myDonation = result.data.data;
      if(result.data.list != ''){
        for (let i = 0; i < result.data.list.length; i++) {
          this.donationDetail.push(result.data.list[i]);
          if(result.data.list[i].openid == this.openid){
             this.sort = result.data.list[i].ranking;
             this.sums = result.data.list[i].totalMoney;
             return;
          }
        }
      }else{
        this.donationDetail = [];
        this.sort = ''
        this.sums = '';
        return;
      }


      this.lastPage = result.data.lastPage;



    },
    // 懒加载
    onLoad() {
      this.postDonationList.currentPage = this.postDonationList.currentPage + 1;
      this.getDonationList();
      this.loading = false;
      // 数据全部加载完成
      if (this.postDonationList.currentPage >= this.lastPage) {
        this.finished = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ranking {
  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
  padding: 1.14rem;
}

.myRank {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url('../../assets/image/btn_kapian_nor.png');
  background-size: 100% 100%;
}

.myRankImg {
  width: 100%;
}

.myRankNum {
  float: left;
  padding: 0px 0px 0px 20px;
  font-size: 1.2rem;
  font-weight: bold;
  height: 1.1rem;
}

.myRankWord {
  float: left;
  padding: 30px 0px 30px 0px;
  font-size: 1.2rem;
  font-weight: bold;
}

.myRankMoney {
  float: left;
  padding: 30px 20px 30px 0px;
  font-size: 1.2rem;
  font-weight: bold;
}

.myRankWordZero {
  float: left;
  padding: 30px 0px 30px 30px;
  font-size: 1.1rem;
  font-weight: bold;
}

.donationBtn {
  border: 0;
  border-radius: 15px;
  margin-right: 30px;
  padding: 5px 20px 5px 20px;
  color: white;
  background: linear-gradient(270deg, #00706E, #00706E);
}

.table {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/Ranking.vue